import React from 'react';
import PropTypes from 'prop-types';

import FacetContent from './FacetContent';

const FacetsContent = ({
  disabled,
  facets,
  facetTypeKey,
  groupIndex,
  onChange,
  title,
}) => (
  <>
    {!!title &&
      <h4 className="Facets_contentTitle">{title}</h4>
    }
    <ul className="Facets_facets">
      {facets.map(facet => (
        <FacetContent
          campsiteType={facet.campsiteType}
          checked={facet.checked}
          disabled={disabled}
          facetTypeKey={facetTypeKey}
          groupIndex={groupIndex}
          id={facet.id}
          name={facet.name}
          onChange={onChange}
          stat={facet.stat}
          key={`${facetTypeKey}${facet.id}`}
        />
      ))}
    </ul>
  </>
);

FacetsContent.propTypes = {
  disabled: PropTypes.bool,
  facets: PropTypes.arrayOf(PropTypes.shape({
    campsiteType: PropTypes.string,
    checked: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    stat: PropTypes.number,
  })),
  facetTypeKey: PropTypes.string,
  groupIndex: PropTypes.number,
  onChange: PropTypes.func,
  title: PropTypes.string,
};

FacetContent.defaultProps = {
  disabled: false,
};

export default FacetsContent;
